import React from 'react';
import { updatedata } from "../../util/global";
import { deliverypartneritem } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: deliverypartneritem;
  setformdata: (data: deliverypartneritem) => void;
  fetchdata: () => void;
}

const DeliveryPartnerForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata
}) => {
  if (showmodal !== "showdeliverypartnerform") return null;

  const handlesave = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: "deliverypartnerdata"
      }
    };
    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "edit delivery partner" : "add delivery partner"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>name</label>
            <input
              type="text"
              className="form-input"
              value={formdata.name || ''}
              onChange={(e) => setformdata({ ...formdata, name: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>phone</label>
            <input
              type="text"
              className="form-input"
              value={formdata.phone || ''}
              onChange={(e) => setformdata({ ...formdata, phone: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>status</label>
            <select
              className="form-input"
              value={formdata.status || 'active'}
              onChange={(e) => setformdata({ ...formdata, status: e.target.value })}
            >
              <option value="active">active</option>
              <option value="inactive">inactive</option>
            </select>
          </div>

          <button className="btn-blue full-width" onClick={handlesave}>
            save delivery partner
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPartnerForm;
